import React from "react";
import {FormatCurrencyWithoutSymbol, FormatRupiah} from "../../../../Services/Utils";

export const formGroupOnSubmission = {
    nomorPengajuan: {value: ""},
    tanggalPengajuan: {value: ""},
    kodeSamsat: {value: null},
    noSupplier: {value: null},
    noBKK: {value: ""},
    bbnId: {value: null},
    dataDetail: {value: []}
}

export const initialData = {
    search: {
        startDateSubmission: null,
        endDateSubmission: null,
    },
    filter: {
        noFakturJual: null,
        startDate: null,
        endDate: null,
        namaSamsat: null,
        namaBirojasa: null,
        stnkName: null,
        customerName: null,
        frameNumber: null,
        engineNumber: null,
    }
}

export const tableColumns = {
    firstPage: [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {page, rowsPerPage} = tableMeta.tableState;
                    const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                    return <>{rowNumber}</>;
                },
                sort: false,
            },
        },
        {
            name: "tanggalPengajuan",
            label: "Tanggal Pengajuan",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "nomorPengajuan",
            label: "Nomor Pengajuan",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "dataSamsat",
            label: "Nama SAMSAT",
            options: {
                customBodyRender: (val) => <p>{val?.samsatName}</p>,
                sort: false,
            },
        },
        {
            name: "dataBirojasa",
            label: "Nama Birojasa",
            options: {
                customBodyRender: (val) => <p>{val?.supplierName}</p>,
                sort: false,
            },
        },
        {
            name: "totalItem",
            label: "Total Item",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "totalBBN",
            label: "Total BBN (Rp)",
            options: {
                customBodyRender: (val) => {
                    return <>{FormatCurrencyWithoutSymbol({number:val})}</>;
                },
                sort: false,
            },
        },
    ],
    secondPage: [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {page, rowsPerPage} = tableMeta.tableState;
                    const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                    return <>{rowNumber}</>;
                },
                sort: false,
            },
        },
        {
            name: "tanggalFakturJual",
            label: "Tanggal Faktur Jual",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "nomorFakturJual",
            label: "Nomor Faktur Jual",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "nomorBuku",
            label: "No. Buku",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "dataVariant",
            label: "Kode Varian",
            options: {
                customBodyRender: (val) => <p>{val?.kodeVariant}</p>,
                sort: false,
            },
        },
        {
            name: "dataVariant",
            label: "Nama Varian",
            options: {
                customBodyRender: (val) => <p>{val?.namaVariant}</p>,
                sort: false,
            },
        },
        {
            name: "dataWarna",
            label: "Kode Warna",
            options: {
                customBodyRender: (val) => <p>{val?.kodeWarna}</p>,
                sort: false,
            },
        },
        {
            name: "dataWarna",
            label: "Nama Warna",
            options: {
                customBodyRender: (val) => <p>{val?.namaWarnaKomersil}</p>,
                sort: false,
            },
        },
        {
            name: "namaSTNK",
            label: "Nama STNK",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "namaPembeli",
            label: "Nama Pembeli",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "nomorRangka",
            label: "Nomor Rangka",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "nomorMesin",
            label: "Nomor Mesin",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "nominalBBN",
            label: "BBN (Rp)",
            options: {
                customBodyRender: (val) => <p>{FormatRupiah({number: val})}</p>,
                sort: false,
            },
        },
    ],
    thirdPage: [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {page, rowsPerPage} = tableMeta.tableState;
                    const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                    return <>{rowNumber}</>;
                },
                sort: false,
            },
        },
        {
            name: "tanggalFakturJual",
            label: "Tanggal Faktur Jual",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "nomorFakturJual",
            label: "Nomor Faktur Jual",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "nomorBuku",
            label: "No. Buku",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "dataVariant",
            label: "Kode Varian",
            options: {
                customBodyRender: (val) => <p>{val?.kodeVariant}</p>,
                sort: false,
            },
        },
        {
            name: "dataVariant",
            label: "Nama Varian",
            options: {
                customBodyRender: (val) => <p>{val?.namaVariant}</p>,
                sort: false,
            },
        },
        {
            name: "dataWarna",
            label: "Kode Warna",
            options: {
                customBodyRender: (val) => <p>{val?.kodeWarna}</p>,
                sort: false,
            },
        },
        {
            name: "dataWarna",
            label: "Nama Warna",
            options: {
                customBodyRender: (val) => <p>{val?.namaWarnaKomersil}</p>,
                sort: false,
            },
        },
        {
            name: "namaSTNK",
            label: "Nama STNK",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "namaPembeli",
            label: "Nama Pembeli",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "nomorRangka",
            label: "Nomor Rangka",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "nomorMesin",
            label: "Nomor Mesin",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
    ]
}

const getColor = (val) => {
    switch (val) {
        case "Lunas":
            return "lime";
        case "Belum Lunas":
            return "red";
        default:
            return "#E6E6E6";
    }
}


export function downloadPdf(blob, fileName) {
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

export async function printPDF(data) {
  try {
    const blobUrl = URL.createObjectURL(data);

    const printWindow = window.open("", "_blank");
    if (!printWindow) return;

    printWindow.document.write(`
          <html>
            <head>
              <title>Print PDF</title>
              <link rel="icon" type="image/x-icon" href="/iconnagamas.ico" />
              <style>
                html, body { margin: 0; padding: 0; height: 100%; overflow: hidden; }
                iframe { width: 100%; height: 100%; border: none; }
              </style>
            </head>
            <body>
              <iframe id="pdfFrame" src="${blobUrl}"></iframe>
              <script>
                const iframe = document.getElementById('pdfFrame');
                iframe.onload = function () {
                  setTimeout(() => {
                    iframe.contentWindow.focus();
                    iframe.contentWindow.print();
                  }, 500);
                };
              </script>
            </body>
          </html>
        `);

    printWindow.document.close();
  } catch (error) {
    console.error("Failed to load or print PDF Blob:", error);
  }
};